
export class CacheConfig {

    type: CacheConfigType;
    private key: string;
    extraKeyIdentifier: string
    invalidate: boolean;

    constructor(type: CacheConfigType, key: CacheConfigKey, extraKeyIdentifier = null, invalidate: boolean = false) {
        this.type = type;
        this.key = key;
        this.extraKeyIdentifier = extraKeyIdentifier;
        this.invalidate = invalidate;
    }

    getKey() {
        if (this.extraKeyIdentifier && this.extraKeyIdentifier != "") {
            return this.key + "-" + this.extraKeyIdentifier;
        }
        return this.key;
    }
}

export enum CacheConfigType {
    MEMORY = 0,
    SESSION = 1
}

export enum CacheConfigKey {
    PRIVACY_POLICY_DATA = "privacyPolicyData",
    BUSINESS_CATEGORY_DATA = "businessCategoriesData",
    USER_THEME = "userThemeData",
    BANNER = "bannerData",
    STATIC_PAGES = "staticPagesData",
}